import React from "react";

export function Input(props) {
    let {title, name, change , value} = props;
    return (
        <div className="inputBox">
            <label>{title}</label>
            <input onChange={change} type="text" name={name} value={value}/>
        </div>
    )
}

export function TextArea(props) {
    let {title, name, change , value} = props;
    return (
        <div className="inputBox">
            <label>{title}</label>
            <textarea style={{height: 'auto'}} rows="10" onChange={change} name={name} value={value}/>
        </div>
    )
}

export function Button(props) {
    let {className, title, type} = props;
    return (
        <div className="inputBox">
            <button type={type} className={className}>{title}</button>
        </div>
    )
}

export function Select(props) {
    let {options, title, name, change} = props;
    return (
        <div className="inputBox">
            <label>{title}</label>
            <select onChange={change} name={name}>
                {options.map((option, index) => {
                    return (
                        <option value={option} key={index}>
                            {option}
                        </option>
                    )
                })}
            </select>
        </div>
    )
}